<template>
  <v-card color="primary" class="rounded-sm">
    <v-card-text>
      <v-container>
        <v-form v-model="cupForm" ref="form">
          <v-row>
            <v-col cols="12">
              <BaseInput v-model="cupFormData.cup">
                <template v-slot:label>CUP</template>
              </BaseInput>
              <v-menu
                v-model="menuVigenciaCup"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="vigenciaCupFormatted"
                    label="Vigencia CUP"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato de fecha: DD/MM/YYYY"
                  />
                </template>
                <v-date-picker
                  v-model="cupFormData.vigenciaCup"
                  @input="menuVigenciaCup = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>

              <v-file-input
                v-model="cupFormData.urlAdjunto"
                label="Oficio adjunto"
                rounded
                filled
                background-color="primary"
                color="secondary"
                dense
              ></v-file-input>

              <v-textarea
                label="Observaciones"
                v-model="cupFormData.observaciones"
                no-resize
                rows="4"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton @click="triggerUpdateCup()" :loading="loading">Actualizar CUP</TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'
import moment from 'moment'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
    cupToUpdate: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      cupForm: false,
      loading: false,
      menuVigenciaCup: false,
      cupFormData: {
        cup: '',
        vigenciaCup: '',
        observaciones: '',
        urlAdjunto: null,
      },
    }
  },
  computed: {
    vigenciaCupFormatted() {
      return this.cupFormData.vigenciaCup && moment(this.cupFormData.vigenciaCup, 'YYYY-MM-DD').isValid()
        ? moment(this.cupFormData.vigenciaCup, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
  },
  watch: {
    cupToUpdate: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.cupFormData = {
            cup: newVal.cup || '',
            vigenciaCup:
              newVal.vigenciaCup && moment(newVal.vigenciaCup, 'DD/MM/YYYY hh:mm:ss a').isValid()
                ? moment(newVal.vigenciaCup, 'DD/MM/YYYY hh:mm:ss a').format('YYYY-MM-DD')
                : null,
            observaciones: newVal.observaciones || '',
            urlAdjunto: null,
          }
        }
      },
    },
  },
  methods: {
    ...mapActions('cups', ['updateCup']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async triggerUpdateCup() {
      try {
        if (!this.cupToUpdate || !this.cupToUpdate.idHistCup) {
          console.error('El idHistCup es inválido o no está definido:', this.cupToUpdate)
          this.SET_SNACKBAR_MESSAGE('No se puede actualizar el CUP. El identificador es inválido.')
          return
        }

        this.loading = true

        let formData = new FormData()
        formData.append('CUP', this.cupFormData.cup)
        formData.append(
          'vigenciaCup',
          this.cupFormData.vigenciaCup ? moment(this.cupFormData.vigenciaCup).format('DD/MM/YYYY HH:mm:ss a') : ''
        )
        formData.append('observaciones', this.cupFormData.observaciones || '')

        if (this.cupFormData.urlAdjunto) {
          formData.append('adjunto', this.cupFormData.urlAdjunto)
        }

        await this.updateCup({
          idPersonal: this.idPersonal,
          idHistCup: this.cupToUpdate.idHistCup,
          payload: formData,
        })

        this.resetForm()
        this.$emit('close')
      } catch (error) {
        console.error('Ocurrió un error al actualizar el CUP:', error)
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al actualizar el CUP.')
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.cupFormData = {
        cup: '',
        vigenciaCup: null,
        observaciones: '',
        urlAdjunto: null,
      }
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>
